import type { ReactNode } from "react";

interface Props {
  label: string;
  value: ReactNode;
  hint?: ReactNode;
  hintTone?: "green" | "gray";
}

export function StatTile({ label, value, hint, hintTone = "green" }: Props) {
  const hintColor = hintTone === "green" ? "text-fh-green" : "text-fh-gray";
  return (
    <div className="flex-1 min-w-[160px] bg-white border border-fh-gold rounded-[14px] px-[18px] py-4">
      <div className="text-[12.5px] text-fh-gray mb-1.5">{label}</div>
      <div className="font-serif text-[24px] text-fh-green-dark leading-tight">{value}</div>
      {hint && <div className={`mt-1 text-[12px] ${hintColor}`}>{hint}</div>}
    </div>
  );
}
